import {Component, Input, OnInit} from '@angular/core';
import {SafeResourceUrl} from "@angular/platform-browser";
import {BasePageComponent} from "../../base-page.component";
import {AuthService} from "../../services/auth.service";
import {ChangePassword, LoginRequest, ResetPassword, SignInRequest} from '../../models/auth.models';
import { RegistrationService } from 'src/app/services/domain/registration.service';
import { RegistrationRequest } from 'src/app/models/registrazione.models';
import { RegistryService } from 'src/app/services/domain/registry.service';
import { PatternValidator } from '@angular/forms';
import { SettingsComponent } from '../settings/settings.component';
import { ActivatedRoute } from '@angular/router';

//lasciare SignInRequest o crearne uno nuovo?

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css'],
  providers: []

})
export class ConfirmComponent extends BasePageComponent implements OnInit {

  public loginRequestModel : SignInRequest = new SignInRequest();

    constructor(private registrationService : RegistrationService){
      super();
    }

    ngOnInit(): void {
    }
  
    public confirmEmail(username : string){
      if (username == ""){
        this.showError("Email Non Valida");
      }
      else{
        this.asyncCall(() => this.registrationService.resendConfirmationEmail(this.loginRequestModel.username), response => {
          this.showSuccess("Email inviata");
        });
        
      }

    }

}
